import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';

@Component({
	selector: 'app-attachment-description-modal',
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TextareaControlComponent],
	templateUrl: './attachment-description-modal.component.html',
	styleUrl: './attachment-description-modal.component.scss',
})
export class AttachmentDescriptionModalComponent implements OnInit {
	@Input() description: string | null;
	@Output() descriptionSaved: EventEmitter<string> = new EventEmitter<string>();
	private activeModal = inject(NgbActiveModal);
	form: FormGroup<{ description: FormControl<string | null> }>;

	ngOnInit(): void {
		this.form = new FormGroup<{ description: FormControl<string | null> }>({
			description: new FormControl<string | null>(this.description, [Validators.minLength(0), Validators.maxLength(100)]),
		});
	}
	closeModal(): void {
		this.activeModal.close();
	}

	save(): void {
		this.descriptionSaved.emit(this.form.controls.description.value!);
		this.closeModal();
	}
}
